import React from "react";
import Image from "next/image";
import Link from "next/link";

export function CompareTable() {
     return ( 
        <div className="comparetablecon">
            <table className="comparetable" cellPadding={0} cellSpacing={0}>
            <thead>
                <tr>
                    <td></td>
                    <td><Image width={135} height={34} src="/app/Assets/adaptive-name.svg"/></td>
                    <td>Structured Finance</td>
                    <td>Buffered ETF</td>
                    <td>Do-It-Yourself</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td align="start">Downside Protection</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                </tr>
                <tr>
                    <td className="align-left">Live Prices</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td>Maybe</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                </tr>
                <tr>
                    <td>Easy to Use</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                </tr>
                <tr>
                    <td>Transparent</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                </tr>
                <tr>
                    <td>Personalized</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                </tr>
                <tr>
                    <td>Low Minimums</td>
                    <td><Image width={24} height={24} src="/app/Assets/true.svg"/></td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                    <td>Maybe</td>
                    <td><Image width={24} height={24} src="/app/Assets/false.svg"/></td>
                </tr>
            </tbody>
            </table>
        </div>       
    )
    }
export default CompareTable;


